import React, { useState } from "react";
import MenuLegged from "../header/Menu";
import Footer from "../footer/Footer";
// import Breadcrumb from "../breadcrumb/breadcrumb";
import Breadcrumb from "../public/breacrumb/breadcrumb";

import { FaHome } from "react-icons/fa";
import { useLocation, useParams } from "react-router-dom";
import Sidebar from "./sidebar/sidebar"; 
import styles from "./layouts.module.css";

const HospitalManagement = () => {
  const { section, subsection, action } = useParams();
  // console.log("section:" , section,' subsection: ', subsection);
  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "สำหรับโรงพยาบาล", url: "" },
    ...(section === "setting"
      ? [{ name: "ตั้งค่าโรงพยาบาล", url: "/hospital/settings" }]
      // : section === "hospitalsetting"
      // ? [{ name: "ตั้งค่าโรงพยาบาล", url: "/hospital/settings" }]
      : [{ name: "ไม่พบเมนู", url: "/" }]),
  ];

  return (
    <>
      {/* <MenuLegged menuActive={"hospitalsetting"} />  */}
      <div className={styles.Breadcrumb} style={{marginTop: '5px'}}>
        <Breadcrumb pathItems={pathItems} />
      </div>
      {/* <div className="global-page"> */}
      <div className={`${styles.Sidebar} layout-page`}>
        <div style={{ display: "flex" }}>
          <Sidebar
            role={"hospital"}
            page={section}
            subsection={subsection}
            action={action}
          />
        </div>
      </div>

  
    </>
  );
};

export default HospitalManagement;
